import { UserGroupsRoutePath } from "#src/routes/settings/users/groups";
import { RoutePath } from "#src/utils/route";

export const UserGroupCategoriesRoutePath = UserGroupsRoutePath.concat(
  new RoutePath({
    path: "/categories",
    title: "User Group Categories",
  })
);
